<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    LoaderInfo(v-show="isLoadingInfo" :actual="itemsGuardados" :total="totalInfo")
    section.section(v-show="verContenido")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Importar Movimientos de Tags&nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times  
        .columns
          .column.is-12
            input.excel-upload-input(ref='excel-upload-input' type='file' accept='.xlsx, .xls' @change='handleClick' v-show="verDrop")
            .drop(@drop='handleDrop' @dragover='handleDragover' @dragenter='handleDragover' v-show="verDrop")
              | Arrastra un archivo de excel ...
        .columns
          .column.is-12.has-text-centered
            a.button.is-dark(@click="handleUpload" v-show="verDrop")
              | Subir Excel &nbsp
              i.fas.fa-upload
            a.button(@click="handleCancel" v-show="!verDrop")
              | Limpiar&nbsp
              span.icon
                i.fas.fa-trash
        .columns
          .column.is-12(v-show="verTablaMovimientos")
            TbTagsMovimientos(:movs="movimientos")
          .column.is-12(v-show="verTablaAsignaciones")
            TbTagsAsignaciones(:asigns="asignaciones")
        .columns
          .column.is-12
            a.button.is-success(@click="subirData" v-show="!verDrop")
              | Guardar Registros &nbsp
              i.fas.fa-save
            | &nbsp
            a.button(@click="handleCancel" v-show="!verDrop")
              | Limpiar&nbsp
              span.icon
                i.fas.fa-trash
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import LoaderInfo from '@/components/shared/LoaderInfo.vue'
  import TbTagsMovimientos from './componentes/TbTagsMovimientos.vue'
  import TbTagsAsignaciones from './componentes/TbTagsAsignaciones.vue'
  import * as XLSX from 'xlsx'
  import InventarioServices from '@/services/inventario/inventario'

  export default {
    name: 'ImportatTags',
    components: { NavBar, Loader, TbTagsMovimientos, TbTagsAsignaciones, LoaderInfo },
    data() {
      return {
        isLoading: false,
        isLoadingInfo: false,
        excelData: {
          header: null,
          results: null
        },
        filas: null,
        tableData: [],
        verDrop: true,
        verTablaAsignaciones: false,
        verTablaMovimientos: false,
        movimientos: [],
        asignaciones: [],
        isDisabled: true,
        itemsGuardados: 0,
        tags: [],
        cruces: [],
        itemsNoGuardados: [],
        totalInfo: 0,
        verContenido: true
      }
    },
    watch: {
      'excelData.header'() {
        if (this.excelData.header) {
          if (this.excelData.header.length > 6) {
            this.verTablaMovimientos = true
            this.verTablaAsignaciones = false
            this.movimientos = this.excelData.results.map(this.convertirMovimientos)
          } else {
            this.verTablaMovimientos = false
            this.verTablaAsignaciones = true
            this.asignaciones = this.excelData.results.map(this.convertirAsignaciones)
          }
          this.isDisabled = false
        } else {
          this.isDisabled = true
        }
      },

      isLoading () {
        if (this.isLoading || this.isLoadingInfo) {
          this.verContenido = false
        } else {
          this.verContenido = true
        }
      },

      isLoadingInfo () {
        if (this.isLoading || this.isLoadingInfo) {
          this.verContenido = false
        } else {
          this.verContenido = true
        }
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerTags()
      },

      obtenerTags() {
        InventarioServices.getTags_All()
          .then((data) => {
            this.tags = data.map(this.convertirTags)
            this.obtenerCruces()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban','OK')
          })
      },
      convertirTags (t) {
        return {
          ...t,
          id: parseInt(t.id)
        }
      },

      obtenerCruces () {
        InventarioServices.getTags_Cruces()
          .then((data) => {
            this.cruces = data.map(this.convetirCruces)
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban','OK')
          })
      },

      convetirCruces (c) {
        return {
          ...c,
          id: parseInt(c.id)
        }
      },

      generateData({ header, results }) {
        this.excelData.header = header
        this.excelData.results = results
        this.filas = results
        this.onSuccess && this.onSuccess(this.excelData)
      },
      
      handleDrop(e) {
        e.stopPropagation()
        e.preventDefault()
        if (this.isLoading) return
        const files = e.dataTransfer.files
        if (files.length !== 1) {
          this.$message.error('Only support uploading one file!')
          return
        }
        const rawFile = files[0] // only use files[0]
        if (!this.isExcel(rawFile)) {
          this.$message.error('Only supports upload .xlsx, .xls, .csv suffix files')
          return false
        }
        this.upload(rawFile)
        e.stopPropagation()
        e.preventDefault()
      },

      handleDragover(e) {
        e.stopPropagation()
        e.preventDefault()
        e.dataTransfer.dropEffect = 'copy'
      },

      handleUpload() {
        this.$refs['excel-upload-input'].click()
      },

      handleClick(e) {
        const files = e.target.files
        const rawFile = files[0] // only use files[0]
        if (!rawFile) return
        this.upload(rawFile)
      },

      handleCancel() {
        this.excelData.header = null
        this.excelData.results = null
        this.movimientos = []
        this.asignaciones = []
        this.verDrop = true
        this.verTablaAsignaciones = false
        this.verTablaMovimientos = false
      },

      upload(rawFile) {
        this.verDrop = false
        this.$refs['excel-upload-input'].value = null // fix can't select the same excel
        if (!this.beforeUpload) {
          this.readerData(rawFile)
          return
        }
        const before = this.beforeUpload(rawFile)
        if (before) {
          this.readerData(rawFile)
        }
      },
      
      readerData(rawFile) {
        this.isLoading = true
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = e => {
            const data = e.target.result
            const workbook = XLSX.read(data, { type: 'array' })
            const firstSheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[firstSheetName]
            const header = this.getHeaderRow(worksheet)
            const results = XLSX.utils.sheet_to_json(worksheet)
            this.generateData({ header, results })
            this.isLoading = false
            resolve()
          }
          reader.readAsArrayBuffer(rawFile)
        })
      },
      
      getHeaderRow(sheet) {
        const headers = []
        const range = XLSX.utils.decode_range(sheet['!ref'])
        let C
        const R = range.s.r
        /* start in the first row */
        for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
          /* find the cell in the first row */
          let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
          headers.push(hdr)
        }
        return headers
      },
      
      isExcel(file) {
        return /\.(xlsx|xls|csv)$/.test(file.name)
      },

      backToPage () {
        this.$router.back()
      },

      convertirMovimientos (mov) {
        return {
          ...mov,
          carril: mov.Carril,
          caseta: mov.Caseta,
          clase: Number(mov.Clase),
          consecar: mov.Consecar,
          fecha: mov.Fecha,
          fechaAplicacion: mov['Fecha Aplicacion'],
          hora: mov.Hora,
          importe: Number(mov.Importe) * -1,
          noEconomico: mov['No.Economico'],
          tag: mov.Tag.substring(0, mov.Tag.length - 2),
        }
      },

      convertirAsignaciones (asign) {
        const _importe = asign.Importe.substring(1, asign.Importe.length)
        console.log(_importe)
        return {
          ...asign,
          fecha: asign.Fecha,
          folio: asign.Folio,
          hora: asign.Hora,
          importe: Number(_importe),
          referencia: asign.Referencia.substring(0, asign.Referencia.length - 2),
          movimiento: asign.Movimiento,
        }
      },
      
      subirData () {
        this.isLoadingInfo = true
        if (this.verTablaMovimientos) {
          this.totalInfo = this.movimientos.length
          this.movimientos.map( mov => {
            const tag = this.tags.find( t => t.numero === mov.tag)
            const cruce = this.cruces.find( c => c.nombre === mov.carril)

            if (tag) {
              if (cruce) {
                const id_tag = tag.id
                const id_cruce = cruce.id
                const _fechaYear = mov.fecha.substring(6, mov.fecha.length)
                const _fechaMonth = mov.fecha.substring(3, 5)
                const _fechaDay = mov.fecha.substring(0, 2)
                const periodo = `${_fechaYear}${_fechaMonth}_1`
                const fechaCompleta = `${_fechaYear}-${_fechaMonth}-${_fechaDay} ${mov.hora}`
                InventarioServices.addTag_Movimiento(id_tag, fechaCompleta, periodo, mov.importe, 0, 0, mov.clase, id_cruce)
                  .then( resp => {
                    if (resp.success) {
                      this.itemsGuardados = this.itemsGuardados + 1
                    } else {
                      this.itemsNoGuardados.push(mov)
                    }
                    const totalItems = this.itemsGuardados + this.itemsNoGuardados.length
                    if (totalItems == this.movimientos.length) {
                      this.isLoadingInfo = false
                      this.backToPage()
                      return
                    } 
                    setTimeout(() => {
                    }, 30)
                  })
                  .catch( e => {
                    this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
                  })
              } else {
                console.log(`No se encontro el cruce: ${mov.carril}`)  
              }
            
            } else {
              console.log(`No se encontro el tag: ${mov.tag}`)
            }
          })
        } else {
          this.totalInfo = this.asignaciones.length
          this.asignaciones.map( a => {
            const tag = this.tags.find( t => t.numero === a.referencia)

            if (tag) {
              const id_tag = tag.id
              const _fechaYear = a.fecha.substring(6, a.fecha.length)
              const _fechaMonth = a.fecha.substring(3, 5)
              const _fechaDay = a.fecha.substring(0, 2)
              const periodo = `${_fechaYear}${_fechaMonth}_1`
              const fechaCompleta = `${_fechaYear}-${_fechaMonth}-${_fechaDay} ${a.hora}`
              InventarioServices.addTag_Movimiento(id_tag, fechaCompleta, periodo, 0, a.importe, 1, 1, 3)
                .then( resp => {
                  if (resp.success) {
                    this.itemsGuardados = this.itemsGuardados + 1
                  } else {
                    this.itemsNoGuardados.push(a)
                  }
                  const totalItems = this.itemsGuardados + this.itemsNoGuardados.length
                  if (totalItems == this.asignaciones.length) {
                    this.isLoadingInfo = false
                    this.backToPage()
                    return
                  } 
                  setTimeout(() => {
                  }, 30)
                })
                .catch( e => {
                  this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
                })
            } else {
              console.log(`No se encontro el tag: ${a.referencia}`)
            }
          })
        }
        
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

    },

    created () {
      this.iniciarComponente()
    },
  }
</script>

<style scoped>
  .excel-upload-input{
    display: none;
    z-index: -9999;
    }
  .drop{
    border: 2px dashed #54545c;
    width: 100%;
    height: 260px;
    line-height: 260px;
    margin: 0 auto;
    font-size: 24px;
    border-radius: 5px;
    text-align: center;
    color: #54545c;
    position: flex;
    justify-content: center;
    align-items: center;
  }
  .drop:hover {
    border: 2px dashed #d3142c;
    color: #d3142c;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/ImportarTags.vue